import styled from 'styled-components';

export const StyledAdamedExpertReadOnlySection = styled.div`
   display: grid;
   grid-template-columns: 1fr max-content;
   gap: 8px;
`;
